export default "__VITE_ASSET__DoDmjooA__"